import { render, staticRenderFns } from "./PrivateVideoStream.vue?vue&type=template&id=0205c153&"
import script from "./PrivateVideoStream.vue?vue&type=script&lang=ts&"
export * from "./PrivateVideoStream.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateVideoStream.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports